import {PROVIDER_FLAGS} from '@Constants/index.constants.js';

export const PreviewLostState = {
	url: '/lost/:consultationId?showBack',
	title: 'Preview Lost Proposal',
	params: {consultationId: null, showBack: 'true'},
	templateProvider: [
		'providerFlags',
		providerFlags =>
			providerFlags?.[PROVIDER_FLAGS.PRESENTATION_V2]
				? '<preview-lost-v2></preview-lost-v2>'
				: '<preview-lost></preview-lost>',
	],
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		const RoutesSvc = $transition$.injector().get('RoutesResolveSvc');
		return (
			RoutesSvc.getPresentationFlags({trans: $transition$})
				// a failed lookup imports the production page; the providerFlags resolve below
				// reports the failure, so it is not swallowed here
				.catch(() => ({}))
				.then(flags =>
					flags?.[PROVIDER_FLAGS.PRESENTATION_V2]
						? import(
								/* webpackChunkName: "previewLostV2Mod" */
								'@Containers/preview-lost-page/preview-lost-v2.cmp.js'
							)
						: import(
								/* webpackChunkName: "previewLostPageMod" */
								'@Containers/preview-lost-page/preview-lost.cmp.js'
							)
				)
				.then(res => $ocLazyLoad.load({name: res.default}))
				.catch(err => $log.error(err))
		);
	},
	resolve: [
		{
			token: 'canView',
			policy: {when: 'EAGER'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) =>
				RoutesSvc.validateConsultationPrivate({status: 'lost', ...trans.params()}).catch(state =>
					trans.router.stateService.go(state.name, state.params)
				),
		},
		{
			token: 'providerFlags',
			policy: {when: 'LAZY'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) => RoutesSvc.getPresentationFlags({trans}),
		},
	],
};
